import {
  Notice,
  User,
  Scope,
  Role,
  EnterpriseNotice,
  ContentfulNotice,
} from '../types'
import { getNotice, getNotices, getEnterpriseNotices } from './api/contentful'
import { printError } from './log'
import { withProtocol } from './url'

const toScope = (role: Role): Scope => {
  switch (role) {
    case 'member':
    case 'trial':
      return 'login' as Scope
    case 'enterprise':
    case 'moderator':
      return 'enterprise' as Scope
  }

  // For safe, fallback to 'all' scope (handled as guests)
  return 'all' as Scope
}

const order: Scope[] = ['none', 'enterprise', 'login', 'all']
const toIndex = (scope: Scope) => {
  const index = order.indexOf(scope)

  // For safe, fallback to 'none' scope (don't show anyway)
  return index === -1 ? 0 : index
}

const allowedScopes = (user?: User): Scope[] => {
  return user ? order.slice(toIndex(toScope(user.role))) : ['all']
}

export const fetchNotices = async (user: User | undefined) => {
  let notices: Notice[] = []
  try {
    const items = await getNotices(allowedScopes(user))
    notices = items.map((item) =>
      convertNotice({ ...item.fields, id: item.sys.id })
    )
  } catch (e) {
    printError(e)
  }
  return notices
}

export const fetchLatestNotice = async () => {
  let notices: Notice[] = []
  try {
    const items = await getNotices(allowedScopes())
    notices = items.map((item) =>
      convertNotice({ ...item.fields, id: item.sys.id })
    )
  } catch (e) {
    printError(e)
  }
  return notices[0] || null
}

export const fetchEnterpriseNotices = async () => {
  let notices: EnterpriseNotice[] = []
  try {
    const items = await getEnterpriseNotices()
    notices = items.map((item) => ({ ...item.fields, id: item.sys.id }))
  } catch (e) {
    printError(e)
  }
  return notices
}

export const fetchNotice = async (slugOrId: string) => {
  let notice
  try {
    const contentfulNotice = await getNotice(slugOrId)
    notice = convertNotice(contentfulNotice)
  } catch (e) {
    printError(e)
  }
  return notice
}

const convertNotice = (contentfulNotice: ContentfulNotice): Notice => {
  const headerImage = {
    url: withProtocol(contentfulNotice.headerImage.fields.file.url),
    title: contentfulNotice.headerImage.fields.title,
  }

  return {
    ...contentfulNotice,
    headerImage,
  }
}
